"use client";

import { useRouter } from "next/navigation";

export default function BackButton({ className }) {
  const router = useRouter();
  return (
    <button className={className} onClick={() => router.back()}>
      ← Volver
    </button>
  );
}
